import axios from "axios";

export const getVPSMetrics = () => {
   
    const now = new Date();
    const dateTo = now.toISOString();
    //before 24 hourse from now
    const dateFrom = new Date(now.getTime() - 24 * 60 * 60 * 1000).toISOString();
  const response = axios.get(
    "https://developers.hostinger.com/api/vps/v1/virtual-machines/1625862/metrics",
    {
      params: {
        date_from: dateFrom,
        date_to: dateTo,
      },
      headers: {
        Accept: "application/json",
        Authorization:
          "Bearer Yjd4yiCZopj453B8zYd8lXm9e4mMxdg5JBeHmPDb330ca90b",
      },
    },
  );
  return response.then((res)=>res);
};
